import { type ReactElement } from "react";
import { cn } from "../utils/cn";

export interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

/** Inline SVG spinner. Ported from prototype — uses currentColor so it
 * inherits from its parent. `label` is an accessible name; defaults to "Lädt". */
export function Spinner({ size = 14, className, label = "Lädt" }: SpinnerProps): ReactElement {
  return (
    <svg
      role="status"
      aria-label={label}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn("animate-spin", className)}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2.5"
        fill="none"
        strokeDasharray="40 60"
        strokeLinecap="round"
      />
    </svg>
  );
}
